import { IndicatorType } from '../constants/common'
import { ExponentialMovingAverage } from './ema'
import { MainCalculation, OnValueCalculated } from './main'

type Options = {
  fastPeriod: number
  slowPeriod: number
  signalPeriod: number
}

type DefaultCalculatedValuesType = {
  macd: number[]
  signal: number[]
  histogram: number[]
}

export class MACDCalculation extends MainCalculation<Options, DefaultCalculatedValuesType> {
  static type = IndicatorType.Macd

  getDefaultCalculatedValues() {
    return {
      macd: [],
      signal: [],
      histogram: [],
    }
  }

  calculate(onValueCalculated?: OnValueCalculated<typeof this.calculatedValues>) {
    const { close } = this.quote
    const { fastPeriod, slowPeriod, signalPeriod } = this.options
    const emaFast = new ExponentialMovingAverage(fastPeriod)
    const emaSlow = new ExponentialMovingAverage(slowPeriod)
    const emaSignal = new ExponentialMovingAverage(signalPeriod)
    this._calculatedValues = this.getDefaultCalculatedValues()

    for (let i = 0; i < close.length; i++) {
      const d = close[i]

      emaFast.add(d)
      emaSlow.add(d)
      const macd = emaFast.value - emaSlow.value
      emaSignal.add(macd)

      this.calculatedValues.macd[i] = macd
      this.calculatedValues.signal[i] = emaSignal.value
      this.calculatedValues.histogram[i] = macd - emaSignal.value

      if (onValueCalculated?.(this.calculatedValues, i) === false) {
        break
      }
    }
  }
}
